import { Gem, Hammer, Layers, PenTool, Route, ScanEye } from "lucide-react";
import { WHY_US } from "@/data/site";
import { Reveal, SectionHeading } from "@/components/Reveal";

const ICONS = [PenTool, Hammer, Gem, Layers, ScanEye, Route];

export default function WhyUs() {
  return (
    <section data-testid="why-us-section" className="noise-overlay bg-charcoal-card py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
        <SectionHeading
          light
          eyebrow="Why ShilpStones"
          title="The Studio Behind the Stone"
          script="Excellence Builds Tomorrow"
        />
        <div className="mt-16 grid gap-px overflow-hidden rounded-2xl bg-charcoal-border ring-1 ring-charcoal-border sm:grid-cols-2 lg:grid-cols-3">
          {WHY_US.map((w, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={w.title} delay={(i % 3) * 0.1} className="h-full">
                <div
                  data-testid={`why-card-${i}`}
                  className="group flex h-full flex-col bg-obsidian p-8 transition-colors duration-500 hover:bg-[#151310] sm:p-10"
                >
                  <div className="flex items-center justify-between">
                    <Icon className="h-6 w-6 text-gold transition-transform duration-500 group-hover:-translate-y-1" />
                    <span className="font-serif text-2xl italic text-stone-700 transition-colors duration-500 group-hover:text-gold/50">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <h3 className="mt-8 font-display text-sm font-semibold uppercase tracking-[0.25em] text-gold-soft">
                    {w.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-stone-400">{w.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
